import React from "react"
import { Row, Col } from "react-bootstrap"

import PropertyCards from "./PropertyCards"

import propertyListStyles from "./PropertyList.module.css"

import { routeHostByPref } from "./footer"

function PageTitle({ pref, propertyType }) {
  const type = listReturnTitle(pref, propertyType)

  return (
    <h1
      className={`mt-0 mb-0 px-2 py-2 border rounded-pill shadow`}
      style={{
        backgroundColor: "#f8f9fa",
        display: "inline-block",
        width: "100%",
        minWidth: "280px",
        maxWidth: "400px",
        fontSize: "1.5rem",
      }}
    >
      {type}
    </h1>
  )
}

function listReturnTitle(pref, propertyType) {
  const type =
    propertyType === "used"
      ? "中古住宅"
      : propertyType === "rental"
      ? "賃貸"
      : ""
  return type
}

function PropertyList({ properties }) {
  return (
    <>
      <nav aria-label="breadcrumb">
        <ol className={`breadcrumb ${propertyListStyles.breadcrumbCustom}`}>
          <li className="breadcrumb-item">
            <a
              href={`${routeHostByPref(
                properties[0].pref
              )}house/home.html#home_service`}
            >
              住宅取扱いトップ
            </a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {listReturnTitle(properties[0].pref, properties[0].propertyType)}
          </li>
        </ol>
      </nav>

      <div
        className="p-5 container mx-auto border rounded  shadow-lg text-center"
        style={{
          height: `${properties.length * 350}px`,
          backgroundColor: "#e6e6e6",
          opacity: "0.8",
        }}
      >
        <PageTitle
          pref={properties[0].pref}
          propertyType={properties[0].propertyType}
        />
      </div>

      <div
        className="text-center mx-auto"
        style={{
          position: "relative",
          marginTop: `-${properties.length * 350 - 140}px`,
          zIndex: "1",
        }}
      ></div>

      <div className="mx-auto" style={{ maxWidth: "991px" }}>
        <Row className="mx-auto">
          <Col xs={12}>
            <PropertyCards properties={properties} />
          </Col>
        </Row>
        <div className="mx-auto text-center" style={{ maxWidth: "767px" }}>
          <small
            className="mt-2 p-3 alert-success text-left"
            role="alert"
            style={{ display: "inline-block", fontSize: "0.9rem" }}
          >
            お問合わせ時点で成約となっている場合もございます。あらかじめご了承ください。
          </small>
        </div>
      </div>
    </>
  )
}

export default PropertyList
